interface SkipLinkProps {
  label: string;
  targetId: string;
}

export default function SkipLink({ label, targetId }: SkipLinkProps) {
  return (
    <a
      href={`#${targetId}`}
      className="sr-only focus:not-sr-only focus:fixed focus:left-2 focus:top-2 focus:z-[100] focus:inline-flex focus:min-h-[44px] focus:items-center focus:rounded focus:bg-page focus:px-4 focus:text-sm focus:font-medium focus:text-primary focus:underline focus:outline focus:outline-2 focus:outline-offset-0 focus:outline-focus"
    >
      {label}
    </a>
  );
}
